<aside class="ai-content-disclaimer">
  <div [ngClass]="{'inline-message': inline, 'message': !inline, 'tip': !inline, 'stacked-below-tip': !inline && stackedBelowTip}">
    <i class="material-icons notranslate">auto_awesome</i>
    @if (variant === 'will') {
      <span>The output of this Rule will contain AI generated content</span>
    }
    @if (variant === 'may') {
      <span>The output of this Rule may contain AI generated content</span>
    }
  </div>
</aside>
